export default __webpack_public_path__ + "static/popup-desktop-b5290aab5fb7f75287a17012e080662b.jpg";